// Comportement du textarea de consigne (#reply-instruction) : auto-redimensionnement et
// défilement du placeholder tronqué. onSubmit/onChange sont injectés par l'appelant (outlook.ts)
// plutôt qu'importés directement, pour ne pas dépendre du moteur de génération/du cache.
export const INSTRUCTION_MAX_HEIGHT_PX = 120;

export function autoResizeInstruction(): void {
  const instructionElement = document.getElementById("reply-instruction") as HTMLTextAreaElement;
  // Champ vide : on revient à la hauteur CSS (1 ligne) sans mesurer -- Chromium inclut le
  // placeholder natif (même transparent) dans scrollHeight, et sur un panneau étroit ou un zoom
  // Windows élevé il passe sur 2-3 lignes et gonfle la barre alors que le calque reste sur 1 ligne.
  if (instructionElement.value === "") {
    instructionElement.style.height = "";
    instructionElement.style.overflowY = "hidden";
    return;
  }
  instructionElement.style.height = "auto";
  const contentHeight = instructionElement.scrollHeight;
  instructionElement.style.height = `${Math.min(contentHeight, INSTRUCTION_MAX_HEIGHT_PX)}px`;
  // overflow-y reste a hidden tant que le texte tient : sur le moteur Trident d'Outlook, "auto"
  // affiche en permanence les fleches grises de la scrollbar a droite du placeholder.
  instructionElement.style.overflowY = contentHeight > INSTRUCTION_MAX_HEIGHT_PX ? "auto" : "hidden";
}

// Le placeholder de la consigne peut être tronqué sur un écran étroit. Au survol, on calcule le
// débordement réel (texte vs. largeur visible) et on le fait défiler juste assez pour le lire en
// entier -- voir le calque #reply-instruction-placeholder et son :placeholder-shown dans taskpane.css.
export function bindInstructionPlaceholderMarquee(): void {
  const wrapElement = document.getElementById("reply-instruction-wrap");
  // overlayElement decoupe la fenetre visible (largeur fixe, overflow:hidden, ne bouge jamais) --
  // textElement est l'element qu'on fait glisser dedans. Les deux ne doivent pas etre confondus :
  // animer overlayElement directement deplacerait sa propre zone de decoupe, et le texte deborderait
  // par-dessus les boutons micro/pièce jointe a gauche au lieu de rester decoupe a leur droite.
  const overlayElement = document.getElementById("reply-instruction-placeholder");
  const textElement = document.getElementById("reply-instruction-placeholder-text");

  wrapElement.addEventListener("mouseenter", () => {
    const overflow = textElement.scrollWidth - overlayElement.clientWidth;
    if (overflow <= 0) {
      return;
    }
    textElement.style.setProperty("--placeholder-overflow", `-${overflow}px`);
    textElement.classList.add("is-scrolling");
  });

  wrapElement.addEventListener("mouseleave", () => {
    textElement.classList.remove("is-scrolling");
    textElement.style.removeProperty("--placeholder-overflow");
  });
}

export function bindInstructionInput(onSubmit: () => void, onChange: () => void): void {
  const instructionElement = document.getElementById("reply-instruction") as HTMLTextAreaElement;
  instructionElement.addEventListener("input", () => {
    autoResizeInstruction();
    onChange();
  });
  instructionElement.addEventListener("keydown", (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      onSubmit();
    }
  });
}
